import React from 'react';
import { FormField } from '../form-field';
import TextField from '../text-field';
import { isValue } from 'ui/form/utils';
import { YouTubeFieldProps } from 'ui/form/fields';
import { REQUIRED } from 'ui/form/constants';

interface YouTubeFieldState {}

function youTubeParseUrl(url = '') {
  const regexp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  const matches = url.match(regexp);
  
  if (matches) return matches[1];
  return false;
}

function getYoutubeUrl(videoId) {
  return 'https://www.youtube.com/embed/' + videoId;
}

export default class YouTubeField extends FormField<YouTubeFieldProps, YouTubeFieldState> {
  static getErrors(props: YouTubeFieldProps, formData) {
    const value = isValue(props.value) ? props.value : (formData || {})[props.name];
  
    if (!value && props.required) return REQUIRED;
    return value ? false : 'Invalid YouTube URL';
  }
  
  static getDerivedStateFromProps({ videoId }, { videoId: prevVideoId, url }) {
    if (videoId !== prevVideoId && videoId) {
      url = getYoutubeUrl(videoId);
    }
    
    return { videoId, url };
  }
  
  state = {
    errors: false
  };

  validate() {
    let errors = YouTubeField.getErrors(this.props);
    this.setState({ errors });
    
    return !errors;
  }

  handleChange = change => {
    if (this.props.onChange) this.handleUrlSubmit(change);
  };

  handleUrlSubmit = change => {
    const videoId = youTubeParseUrl(change);
    if (videoId) {
      this.props.onChange(videoId);
      this.setState({errors: false});
    } else {
      this.setState({errors: 'Invalid link'});
    }
  }
  render() {
    const { onChange, value, ...rest } = this.props;
    const { errors } = this.state;

    return (
      <div>
        <TextField
          {...rest}
          value={value && getYoutubeUrl(value)}
          error={errors}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}
